import styled from 'styled-components';

export const Container = styled.main`
  .contester-button {
    margin-right: 20px;
  }
  background-color: transparent;
  .subContainer {
    justify-content: space-around;
    margin-top: 25px;
  }
  .upload-document-button {
    font-weight: normal;
    font-size: 14px;
    width: 100%;
  }
  .validate-button {
    margin-right: 20px;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;
